import { useState } from "react";
import { Download } from "lucide-react";
import type { ImageArtifact } from "~/components/assistant/types";

interface ImageMessageProps {
  image: ImageArtifact;
  debugMode?: boolean;
}

export function ImageMessage({ image }: ImageMessageProps) {
  const [hovering, setHovering] = useState(false);

  return (
    <div
      className="relative inline-block rounded-lg overflow-hidden border border-gray-200 bg-white"
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      aria-label="Image display"
    >
      <img
        src={image.content.url}
        alt={image.summary || image.artifact_name || "Image artifact"}
        className="max-w-full max-h-96 object-contain"
      />

      {hovering && (
        <a
          href={image.content.url}
          download
          className="absolute bottom-3 right-3 flex items-center justify-center size-8 rounded-full bg-black/30 text-white hover:bg-black/50 transition-colors"
          aria-label="Download image"
        >
          <Download className="size-4" />
        </a>
      )}

      {image.summary && (
        <div className="px-3 py-2 text-xs text-gray-600 border-t border-gray-200">
          {image.summary}
        </div>
      )}
    </div>
  );
}
